import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { Input } from "../../components/ui/input";
import { Field, inputCls } from "../../components/forms/Field";
import { LogoMark } from "../../components/site/Logo";
import { api, errMsg } from "../../lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setError("");
    try {
      await api.post("/auth/login", { email, password });
      nav("/admin");
    } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <div className="flex min-h-screen items-center justify-center bg-navy p-4 grid-texture">
      <form onSubmit={submit} className="w-full max-w-md rounded-2xl bg-white p-8 shadow-2xl" data-testid="admin-login-form">
        <LogoMark className="h-14 w-14" />
        <h1 className="mt-5 font-display text-2xl font-extrabold text-navy">Admin Dashboard</h1>
        <p className="mt-1 text-sm text-slate-500">Authorised federation staff only.</p>
        <div className="mt-6 space-y-4">
          <Field label="Email"><Input className={inputCls} type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" /></Field>
          <Field label="Password"><Input className={inputCls} type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" /></Field>
        </div>
        {error && <p className="mt-4 rounded-lg bg-red-50 p-3 text-sm text-red-700" data-testid="login-error">{error}</p>}
        <button type="submit" disabled={busy} className="btn-primary mt-6 w-full" data-testid="login-submit-button">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />} Sign in
        </button>
      </form>
    </div>
  );
}
